/**
 * This code was generated by Builder.io.
 */
import React, { useEffect } from "react";
import styles from "./FinancialPreQualification.module.css";
import BenefitCard from "./BenefitCard";
import AchieveYourGoal from "../../../assets/svg/AchieveYourGoal.svg";
import FasterLoanApproval from "../../../assets/svg/FasterLoanApproval.svg";
import KnowYourBudget from "../../../assets/svg/KnowYourBudget.svg";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import config from "../../../config";
const FinancialPreQualification = () => {
    const benefits = [
        {
            iconSrc: KnowYourBudget,
            title: "Know Your Budget",
            description: "Shop with confidence, knowing your financial limits for better decision-making.",
        },
        {
            iconSrc: AchieveYourGoal,
            title: "Achieve Your Goals",
            description: "Get expert guidance and explore loan options that align with your financial",
        },
        {
            iconSrc: FasterLoanApproval,
            title: "Faster Loan Approval",
            description: "Pre-qualification accelerates approval, giving you a competitive edge.",
        },
    ];
    const navigate = useNavigate();
    const handleGetQualifiedClick = () => {
        // Clear any previous GetQualified form data when starting fresh
        localStorage.removeItem("getQualified_generalInfo");
        localStorage.removeItem("getQualified_stepTwo");
        navigate("/get-qualified/Step-1");
    };
    useEffect(() => {
        document.title = `Financing Service | ${config.get("COMPANY_NAME")}`;
    }, []);
    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <Header title="Apply For Financing" />
            <main className={`${styles.mainContent} tw-overflow-y-auto  tw-flex tw-w-full`}>
                <div></div>
                <section className={`${styles.contentWrapper}     `}>
                    <div className={styles.titleSection}>
                        <h2 className={styles.mainTitle}>Understand Your Financial Situation</h2>
                        <p className={styles.subtitle}>Check your home loan eligibility in just 3 minutes without affecting your credit score!</p>
                    </div>
                    <h3 className={`${styles.sectionTitle} tw-text-start`}>Why Get Pre-Qualified?</h3>
                    <div className={`${styles.benefitsContainer} `}>
                        {benefits.map((benefit, index) => (
                            <BenefitCard key={index} {...benefit} />
                        ))}
                    </div>
                    <div className={`${styles.ctaWrapper} `}>
                        <button onClick={handleGetQualifiedClick} className={`tw-p-[23px] tw-rounded-md tw-bg-primary hover:tw-bg-primary_hover`}>
                            <div className={styles.ctaContent}>
                                <span className={`${styles.ctaText} tw-font-normal`}>Secure Your Home Now</span>
                            </div>
                        </button>
                    </div>
                </section>
                <footer className={styles.footerWrapper}>
                    <p className={styles.footerText}>Your information is safe and secure with us.</p>
                    <a onClick={() => navigate("/privacy-policy")} className={styles.footerLink}>
                        Learn more about our privacy policy
                    </a>
                </footer>
            </main>
        </div>
    );
};

export default FinancialPreQualification;
